import { ActionReducerMap } from '@ngrx/store';
//import { AppState } from './app.state';
import { counterReducer } from './counter/counter.reducer'

//export const reducers: ActionReducerMap<AppState> = {
export const reducers = {
    // counter: counterReducer,
  };
